module.exports = __webpack_public_path__ + "img/MULTIPLY.9602978d.svg";